export default __webpack_public_path__ + "static/media/bg_veloeGO.d114e5ba.jpg";